import { DangerModal, showToast } from '@lokalise/louis';

import type { StyleGuide } from '@app/api/styleGuide';
import { useDeleteStyleGuideMutation } from '@app/api/styleGuide';

import { useStyleGuideContext } from '../../StyleGuideContext';

export const DeleteConfirmationModal = ({ styleGuide, onClose }: { styleGuide?: StyleGuide; onClose: () => void }) => {
    const [deleteStyleGuide, { isLoading }] = useDeleteStyleGuideMutation();
    const { teamId } = useStyleGuideContext();

    if (styleGuide === undefined) {
        return null;
    }

    const { id, name } = styleGuide;

    const onDeleteConfirmation = async () => {
        const response = await deleteStyleGuide({ teamId, styleGuideId: id });

        if ('error' in response) {
            showToast({ type: 'error', title: 'Error while deleting style guide. Please try again.' });

            return;
        }

        onClose();
    };

    return (
        <DangerModal
            opened
            confirmText="Delete"
            title="Delete style guide"
            onClose={onClose}
            onConfirm={onDeleteConfirmation}
            loading={isLoading}
        >
            Deleting the <strong>&apos;{name}&apos;</strong> will permanently remove it from Lokalise, task assignees
            will no longer have access to it.
        </DangerModal>
    );
};

export default DeleteConfirmationModal;
